import { Trans } from '@lingui/react/macro';

import Stack from '@/design_system/Stack';
import Paragraph from '@/design_system/Typography/Paragraph';

export const ServiceNone = () => {
  return (
    <Stack gap="0.5rem">
      <p className="label-100-medium">
        <Trans id="article-services.service-none.label">Services</Trans>
      </p>
      <Paragraph color="secondary">
        <Trans id="article-services.service-none.text">No service is applicable</Trans>
      </Paragraph>
    </Stack>
  );
};
